import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import uniqid from 'uniqid'

import './RadioButtonsGroup.scss'

export const RadioButtonsGroup = ({
  className,
  items,
  onChange,
  name,
  value,
  'data-mu-test': dataAttributeTest
}) => {
  const { current: uuid } = useRef(uniqid('c-button-group'))

  const handleOnChange = e => {
    if (onChange && typeof onChange === 'function') {
      onChange(e.target.value)
    }
  }

  return (
    <div
      className={classnames('c-radio-buttons-group', className)}
      data-mu-test={classnames('radio-buttons-group', dataAttributeTest)}
    >
      {items.map((item, i) => (
        <label
          className={classnames('c-radio-buttons-group__item', {
            'c-radio-buttons-group__item--selected':
              !!value && [].concat(value).includes(item.value),
            'c-radio-buttons-group__item--disabled': item.disabled
          })}
          key={`radio-buttons-group-item-${i}-${uuid}`}
          htmlFor={`${uuid}-${i}`}
          data-mu-test={item['data-mu-test']}
        >
          <input
            type='radio'
            name={name}
            id={`${uuid}-${i}`}
            value={item.value}
            checked={value === item.value}
            disabled={item.disabled}
            onChange={handleOnChange}
          />
          <span> {item.label}</span>
        </label>
      ))}
    </div>
  )
}

RadioButtonsGroup.defaultProps = {
  itemsDisable: []
}

RadioButtonsGroup.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  items: PropTypes.array,
  onChange: PropTypes.func,
  value: PropTypes.any,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
